import { CHANGE_LANGUAGE } from '../constants/language';

export function changeLanguage(lang) {
  return {
    type: CHANGE_LANGUAGE,
    payload: lang
  };
}


// WEBPACK FOOTER //
// ./src/actions/language.js